<template>
    <v-container>
        <v-row>
            <v-col>
                <h1>Reisenkostenabrechnung</h1>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" align="left">
                <router-link to="/">
                    <v-btn color="primary">zurück</v-btn>
                </router-link>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    export default {
        name: "PrintPage"
    }
</script>

<style scoped>

</style>